import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { ICourseType } from "../../../feature-module/pages/masters/courseTypes";

interface ICourseTypesState {
  data: ICourseType[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: ICourseTypesState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllCourseTypes = createAsyncThunk(
  'get/allCourseTypes',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_COURSE_TYPES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const courseTypesSlice = createSlice({
  name: "courseTypes",
  initialState,
  reducers: {
    resetCourseTypesState: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.limit = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCourseTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCourseTypes.fulfilled, (state, action) => {
        state.loading = false;
        const payloadData = action.payload.data || [];
        state.data = payloadData.data || [];
        state.total = payloadData.total || 0;
        state.page = payloadData.page || 1;
        state.limit = payloadData.limit || 10;
        state.error = null;
      })
      .addCase(getAllCourseTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = [];
      });
  },
});

export const { resetCourseTypesState } = courseTypesSlice.actions;
export default courseTypesSlice.reducer;